import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TextInput } from '../../../legacy-design-system/form-text'

export function ServerNameInput({
  value,
  getFormFieldProps,
  onChange,
  isReadOnly
}) {
  return (
    <FormattedMessage id="title_servers_serverName">
      {(labelName) => (
        <TextInput
          disabled={isReadOnly}
          required
          id="serverSettings_name"
          label={labelName}
          value={value}
          onChange={onChange}
          {...getFormFieldProps({ id: 'name' })}
        />
      )}
    </FormattedMessage>
  )
}
